/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import PropTypes from 'prop-types';

import LocalizationConsumer from '../../../l10n/localization-context';
import InsertLinkToAnchor from '../../insert-link-to-anchor';
import Modal from '../../modal';


class InsertLinkToAnchorDialog extends React.Component
{
  static propTypes = {
    isEditMode: PropTypes.bool,
    isLinkEditable: PropTypes.bool,
    isLinkHidden: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onUnlink: PropTypes.func.isRequired,
    anchorName: PropTypes.string,
    linkText: PropTypes.string,
    tooltip: PropTypes.string,
    previewImage: PropTypes.string
  };

  static defaultProps = {
    isEditMode: true,
    isLinkEditable: true,
    isLinkHidden: false,
    anchorName: '',
    linkText: '',
    tooltip: '',
    previewImage: ''
  };

  constructor(props)
  {
    super(props);

    const { anchorName, linkText, tooltip  } = this.props;

    this.state = { anchorName, linkText, tooltip };
  }

  getButtons = () =>
  {
    const { onCancel, onUnlink, isEditMode } = this.props;
    const { anchorName } = this.state;

    const saveButtonName = isEditMode ? <LocalizationConsumer id="insert-link-to-anchor-dialog.button-edit-link" /> :
    <LocalizationConsumer id="insert-link-to-anchor-dialog.button-insert-link" />;

    const buttons = [
      {
        name: saveButtonName,
        buttonHandler: this.savePayload,
        isDisabled: !anchorName
      },
      {
        name: <LocalizationConsumer id="insert-link-to-anchor-dialog.button-cancel" />,
        buttonHandler: onCancel
      }
    ];

    if (isEditMode)
    {
      const unlinkButton =
      {
        name: <LocalizationConsumer id="insert-link-to-anchor-dialog.button-unlink" />,
        buttonHandler: onUnlink
      };

      buttons.splice(1, 0, unlinkButton);
    }

    return buttons;
  };

  savePayload = () =>
  {
    const { anchorName, linkText, tooltip } = this.state;
    const { onSave } = this.props;

    onSave({ anchorName, linkText, tooltip });
  };

  handleChange = (stateKey, value) =>
  {
    this.setState({ [stateKey]: value });
  };

  render()
  {
    const {
      isEditMode,
      isLinkEditable,
      isLinkHidden,
      previewImage,
      onCancel
    } = this.props;

    const { anchorName, linkText, tooltip } = this.state;

    return (
      <Modal
        onCloseDialogClick={onCancel}
        size={{ width: 565 }}
      >
        <Modal.Header>
          <LocalizationConsumer
            id={isEditMode ? 'insert-link-to-anchor-dialog.header.edit' :
              'insert-link-to-anchor-dialog.header.insert'}
          />
        </Modal.Header>
        <Modal.Content>
          <InsertLinkToAnchor
            anchorName={anchorName}
            linkText={linkText}
            tooltip={tooltip}
            isLinkEditable={isLinkEditable}
            isLinkHidden={isLinkHidden}
            previewImage={previewImage}
            isEditMode={isEditMode}
            onChange={this.handleChange}
          />
        </Modal.Content>
        <Modal.Footer>
          {this.getButtons()}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default InsertLinkToAnchorDialog;